import React from 'react';
import { createRoot } from 'react-dom/client';
import * as AppModule from './App';
// import * as serviceWorker from './serviceWorker';
import 'styles/global.sass';

// Find the root container and ensure it exists at runtime.
const container = document.getElementById('root');
if (!container) {
    throw new Error('Root container not found');
}

const root = createRoot(container);

// Support either a default export or a named export from ./App
type AppProps = { tab?: string };
const AppComponent = ((AppModule as any).default || AppModule) as React.ComponentType<AppProps>;

root.render(<AppComponent tab="home" />);

// serviceWorker.unregister?.();
